import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AccountingService } from 'src/app/services/accounting/accounting.service';
import * as moment from 'moment';

@Component({
    selector: 'app-post-fee-daily',
    templateUrl: './post-fee-daily.component.html',
    styleUrls: ['./post-fee-daily.component.css']
})
export class PostFeeDailyComponent implements OnInit {

    constructor(private accService: AccountingService, private spinnerService: Ng4LoadingSpinnerService, private lookupService: LookupService, public globalHelper: GlobalHelper) {

    }
    ExternalUserTypeList: any;
    GetExternalUserType() {
        this.lookupService.GetLookupsList('ExternalUserType', '').subscribe((data) => {

            this.ExternalUserTypeList = data.LookupItems;
        });

    };
    PaymentModeAlert = "";
    SearchModel = {
        ExternalUserTypeID: 0,
        IsPost: false,
        TransID: 0,
        PaidAmount: 0,
        CreditAccID: 0,
        DebitAccID: 0,
        CancelStatus: 'N',
        Amount: 0,
        ClassID: 0,
        SectionID: 0,
        PaymentMode: 0,
        FromDate: '',
        ToDate: '',
        Narration: '',
        CounterTypeID: 0,
        TransDate: moment(new Date()).format('DD-MMM-YYYY'),
    };
    UserComponetLIst: any;
    Check() {

        alert(JSON.stringify(this.UserComponetLIst));
    }
    CurrencyModel = {
        R2000: 0,
        R500: 0,
        R200: 0,
        R100: 0,
        R50: 0,
        R20: 0,
        R10: 0,
        R5: 0,
        R2: 0,
        R1: 0,

        FromDate: moment(new Date()).format('DD-MMM-YYYY'),
        IsActive: true,
        Remarks: '',

    }
    UserList = [];
    PaymentModeList = [];
    PaymentModeAmountList = [];
    PostFeeDailyList = [];
    ResetList() {
        this.UserList = [];
        this.PaymentModeList = [];
        this.PaymentModeAmountList = [];
        this.UserComponetLIst = [];
        this.PostFeeDailyList = [];
    }
    Submitted = false;
    GetPostFeeDaily() {
        this.Submitted = true;
        if (!this.ValidateDropdownSearch()) {
            this.SearchModel.FromDate = moment(this.SearchModel.FromDate).format('DD-MMM-YYYY');
            this.spinnerService.show();
            this.accService.GetPostFeeDaily(JSON.stringify(this.SearchModel)).subscribe((response) => {
                this.UserList = response.UserList;
                this.PaymentModeList = response.PaymentModeList;
                this.UserComponetLIst = response.UserComponetLIst;
                this.PaymentModeAmountList = response.PaymentModeAmountList;
                this.PostFeeDailyList = response.PostFeeDailyList;
                if (this.PostFeeDailyList != null && this.PostFeeDailyList.length > 0) {
                    this.SearchModel.PaidAmount = this.PostFeeDailyList[0].PaidAmount;
                    this.SearchModel.TransID = this.PostFeeDailyList[0].TransID;
                    this.SearchModel.Narration = this.PostFeeDailyList[0].Narration;
                }

                this.spinnerService.hide();
            });

        }
    }
    ValidateDropdownSearch() {
        return this.SearchModel.FromDate == ''


    };
    AmountAlert = true;
    ValidateAmount() {
        this.AmountAlert = true;
        if (this.SearchModel.CounterTypeID != 2) {
            for (var i = 0; i < this.UserComponetLIst.length; i++) {

                if (this.UserComponetLIst[i].CashAmount != this.UserComponetLIst[i].Amount) {
                    this.AmountAlert = false;
                }

            }
        }
        return this.AmountAlert;
        //for (i = 0; i < this.PaymentModeList.length; i++) {

        //    for (j = 0; i < this.PaymentModeList[i].AmountList.length; j++) {

        //        var a = this.PaymentModeList[i].AmountList[j].Amount;
        //    }

        //}

    }
    SubmittedSave = false;
    SelectAlertMsg = '';
    SavePostFeeDaily() {
        if (this.SearchModel.TransID > 0) {
            var r = confirm("Are you sure you want to Re-Post Fee ");
        }
        else {
            r = true;
        }

        if (r == true) {
            var isLock = true;
            var CisLock = true;
            for (var i = 0; i < this.PaymentModeAmountList.length; i++) {
                if (this.PaymentModeAmountList[i].IsLock == false) {
                    var isLock = false;
                    break;
                }
            }

            for (i = 0; i < this.PostFeeDailyList.length; i++) {
                if (this.PostFeeDailyList[i].FeeReceivableAccountID == 0) {
                    var CisLock = false;
                    break;
                }
            }
            if (CisLock) {
                if (isLock) {
                    this.SubmittedSave = true;
                    if (!this.ValidateDropdownSave() && this.ValidateAmount()) {
                        var result = true;
                        if (this.SearchModel.IsPost) {
                            var result = confirm("Are you sure you want to Post?");
                        }
                        if (result) {

                            this.SelectAlertMsg = '';

                            this.spinnerService.show();
                            this.accService.SavePostFeeDaily(JSON.stringify(this.SearchModel), JSON.stringify(this.PostFeeDailyList), JSON.stringify(this.UserComponetLIst), JSON.stringify(this.PaymentModeAmountList)).subscribe((response) => {


                                this.spinnerService.hide();

                                this.SubmittedSave = false;
                                this.GetPostFeeDaily();
                                this.globalHelper.CheckActionStatus(response);

                            });
                        }

                    }
                } else {

                    this.PaymentModeAlert = "Please lock All Payment Mode Account ";
                }
            } else {

                this.PaymentModeAlert = "Please  Set Fee Component  Account ";
            }
        }
    }

    ValidateDropdownSave() {
        return this.SearchModel.Narration == ''


    };
    VoucherTypeList: any;
    GetVoucherType() {
        this.lookupService.GetLookupsList('VoucherType', '').subscribe((data) => {

            this.VoucherTypeList = data.LookupItems;
        });

    };

    //  ChangeVoucherType () {

    //      for (var i = 0; i < this.VoucherTypeList.length; i++) {
    //          if (this.VoucherTypeList[i].ItemCode1 == this.VoucherType) {
    //              var url = this.BranchDetails.AppPath + "Home/Index/#/" + this.VoucherTypeList[i].PageUrl + "?VoucherType=" + this.VoucherTypeList[i].ItemCode1
    //              window.location = url;
    //          }
    //      }



    //  }




















    ngOnInit() {
        this.GetExternalUserType();
    }

}
